import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        root: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        dataGridContainer: {
            '& .MuiDataGrid-main': {
                marginTop: '0 !important',
            },
            '& .MuiDataGrid-toolbar': {
                paddingTop: '0 !important',
                paddingBottom: '0 !important',
            },
        },
    }
})

export default useStyles
